import { ChangeDetectionStrategy, Component } from '@angular/core';
import { UntypedFormControl } from '@angular/forms';

import { ExtendedBaseProfileField } from '../../../../../core/profiles/entities/extended-profile-field.entity';
import { PartialRecord } from '../../../../../core/records/entities/partial-record.class';
import { BatchFieldReadHelper } from '../../../../helpers/fields/batch-field-read.helper';
import { FieldReadHelper } from '../../../../helpers/fields/field-read.helper';
import { ShSimpleInputFieldComponent } from '../simple-input-field/simple-input-field.component';

@Component({
    standalone: false,
    selector: 'sh-long-field',
    templateUrl: './long-input-field.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ShLongInputFieldComponent extends ShSimpleInputFieldComponent {
    constructor(protected fieldHelper: FieldReadHelper) {
        super(fieldHelper);
    }

    init(profileField: ExtendedBaseProfileField, records: PartialRecord[], control: UntypedFormControl): void {
        const value = this.isBatchEdit
            ? BatchFieldReadHelper.getBatchFieldValue(profileField.FieldDefinition)
            : this.fieldHelper.getMergedLongFieldValue(profileField.FieldDefinition, records);
        control.setValue(value);
    }
}
